// plugins/devtools-debugger.client.ts
window.DISABLE_DEBUGGER = true
export default defineNuxtPlugin(() => {
    if (!process.client) return

    // 配置开关：通过 URL 参数 ?debug=true 或全局变量 window.DISABLE_DEBUGGER
    const urlParams = new URLSearchParams(window.location.search)
    const isDisabled = urlParams.get('debug') === 'true' || window.DISABLE_DEBUGGER
    console.log('isDisabled', isDisabled)

    if (isDisabled) {
        console.log('[DevTools Debugger] Disabled by config')
        return
    }

    let devtoolsOpen = false
    let debuggerTriggered = false
    const threshold = 160

    // 核心检测函数
    const detectDevTools = () => {
        const widthDiff = window.outerWidth - window.innerWidth
        const heightDiff = window.outerHeight - window.innerHeight
        const opened = widthDiff > threshold || heightDiff > threshold

        if (opened && !devtoolsOpen) {
            devtoolsOpen = true
            if (!debuggerTriggered) {
                debuggerTriggered = true
                console.log('DevTools opened!')
                debugger
            }
        } else if (!opened && devtoolsOpen) {
            devtoolsOpen = false
            debuggerTriggered = false
            console.log('DevTools closed!')
        }
    }

    // requestAnimationFrame 循环检测
    const loop = () => {
        detectDevTools()
        requestAnimationFrame(loop)
    }
    requestAnimationFrame(loop)

    // 监听窗口 resize
    window.addEventListener('resize', detectDevTools)

    // 监听键盘（F12 / Ctrl+Shift+I / Cmd+Option+I）
    document.addEventListener('keydown', (e) => {
        const key = e.key.toLowerCase()
        if (
            key === 'f12' ||
            (e.ctrlKey && e.shiftKey && key === 'i') ||
            (e.metaKey && e.altKey && key === 'i')
        ) {
            if (!debuggerTriggered) {
                debuggerTriggered = true
                debugger
            }
        }
    })

    // 控制台检测（可选）
    const devtools = /./
    devtools.toString = function () {
        if (!debuggerTriggered) {
            debuggerTriggered = true
            debugger
        }
        return ''
    }
    console.log(devtools)
})
